import { Injectable } from '@angular/core';

export interface IPropDictionary {
  entries: { value: string; text: string;textShort: string; iconOn: boolean }[];
  noEntryFound: {
    text: string;
    iconOn: boolean;
    textShort: string;
  };
}

@Injectable({
  providedIn: 'root'
})
export class PropDictionaryService {
  daikinUnitStatusDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Daikin status error', textShort: 'Daikin status error', iconOn: false },
      { value: '1', text: 'Daikin status OK', textShort: 'Daikin status OK', iconOn: true },
      { value: '-1', text: 'Daikin status NC', textShort: 'Daikin status NC', iconOn: false },
    ],
    noEntryFound: {
      text: 'Daikin status undefined', textShort: 'Daikin status und.',
      iconOn: false,
    },
  };

  daikinUnitFanSpeedDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Daikin fan speed low', textShort: 'Daikin fan speed low', iconOn: true },
      { value: '1', text: 'Daikin fan speed high', textShort: 'Daikin fan speed high', iconOn: true },
      { value: '-1', text: 'Daikin fan speed unknown', textShort: 'Daikin fan speed unk.', iconOn: false },
    ],
    noEntryFound: {
      text: 'Daikin fan speed undefined', textShort: 'Daikin fan speed und.',
      iconOn: false,
    },
  };

  daikinUnitOperationModeDictionary: IPropDictionary = {
    entries: [
      { value: '1', text: 'Daikin mode fan', textShort: 'Daikin mode fan', iconOn: true },
      { value: '2', text: 'Daikin mode heat', textShort: 'Daikin mode heat', iconOn: true },
      { value: '4', text: 'Daikin mode cool', textShort: 'Daikin mode cool', iconOn: true },
      { value: '16', text: 'Daikin mode set point', textShort: 'Daikin mode set point', iconOn: true },
      { value: '32', text: 'Daikin mode ventilation', textShort: 'Daikin mode ventilation', iconOn: true },
      { value: '64', text: 'Daikin mode dry', textShort: 'Daikin mode dry', iconOn: true },
      { value: '256', text: 'Daikin Auto (Heat)', textShort: 'Daikin Auto (Heat)', iconOn: true },
      { value: '512', text: 'Daikin Auto (cool)', textShort: 'Daikin Auto (cool)', iconOn: true },
      { value: '4096', text: 'Daikin mode unknown', textShort: 'Daikin mode unknown', iconOn: false },
    ],
    noEntryFound: {
      text: 'Daikin mode undefined',
       textShort: 'Daikin mode undef.',
      iconOn: false,
    },
  };

  lgUnitOperationModeDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'LG mode Cooling', textShort: 'LG mode cooling', iconOn: true },
      { value: '2', text: 'LG mode Fan', textShort: 'LG mode Fan', iconOn: true },
      { value: '3', text: 'LG mode Auto', textShort: 'LG mode Auto', iconOn: true },
      { value: '4', text: 'LG mode Heating', textShort: 'LG mode Heating', iconOn: true },
    ],
    noEntryFound: {
      text: 'LG mode undefined', textShort: 'LG mode und.',
      iconOn: false,
    },
  };


  lgUnitFanSpeedDictionary: IPropDictionary = {
    entries: [
      { value: '1', text: 'LG fan speed low', textShort: 'LG fan speed low', iconOn: true },
      { value: '2', text: 'LG fan speed mid', textShort: 'LG fan speed mid', iconOn: true },
      { value: '3', text: 'LG fan speed high', textShort: 'LG fan speed high', iconOn: true },
      { value: '4', text: 'LG fan speed auto', textShort: 'LG fan speed auto', iconOn: true },
      { value: '7', text: 'LG fan speed super high', textShort: 'LG fan speed super h.', iconOn: true },

    ],
    noEntryFound: {
      text: 'LG fan speed undefined', textShort: 'LG fan speed und.',
      iconOn: false,
    },
  };

      // LG Unit Status
    // -1 : LG status Undefined
    // 0: LG status OK
    // x: LG Error x
    // handled in GetDictionaryValuePipe
  lgUnitStatusDictionary: IPropDictionary = {
    entries: [
      { value: '-1', text: 'LG status Undefined', textShort: 'LG status Undef.', iconOn: false },
      { value: '0', text: 'LG status OK', textShort: 'LG status OK', iconOn: true },
     /*  { value: '1', text: 'Lg status 1', textShort: 'Lg status 1', iconOn: true }, */
    ],
    noEntryFound: {
      text: 'Lg status undefined', textShort: 'Lg status und.',
      iconOn: false,
    },
  };


  boschUnitOperationModeDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Bosch mode Cooling', textShort: 'Bosch mode cooling', iconOn: true },
      { value: '2', text: 'Bosch mode Fan', textShort: 'Bosch mode Fan', iconOn: true },
      { value: '3', text: 'Bosch mode Auto', textShort: 'Bosch mode Auto', iconOn: true },
      { value: '4', text: 'Bosch mode Heating', textShort: 'Bosch mode Heating', iconOn: true },
    ],
    noEntryFound: {
      text: 'Bosch mode undefined', textShort: 'Bosch mode und.',
      iconOn: false,
    },
  };


  boschUnitFanSpeedDictionary: IPropDictionary = {
    entries: [
      { value: '1', text: 'Bosch fan speed low', textShort: 'Bosch fan speed low', iconOn: true },
      { value: '2', text: 'Bosch fan speed mid', textShort: 'Bosch fan speed mid', iconOn: true },
      { value: '3', text: 'Bosch fan speed high', textShort: 'Bosch fan speed high', iconOn: true },
      { value: '4', text: 'Bosch fan speed auto', textShort: 'Bosch fan speed auto', iconOn: true },
      { value: '7', text: 'Bosch fan speed super high', textShort: 'Bosch fan speed super h.', iconOn: true },

    ],
    noEntryFound: {
      text: 'Bosch fan speed undefined', textShort: 'Bosch fan speed und.',
      iconOn: false,
    },
  };

      // Bosch Unit Status
    // -1 : Bosch status Undefined
    // 0: Bosch status OK
    // x: Bosch Error x
    // handled in GetDictionaryValuePipe
  boschUnitStatusDictionary: IPropDictionary = {
    entries: [
      { value: '-1', text: 'Bosch status Undefined', textShort: 'Bosch status Undef.', iconOn: false },
      { value: '0', text: 'Bosch status OK', textShort: 'Bosch status OK', iconOn: true },
     /*  { value: '1', text: 'Bosch status 1', textShort: 'Bosch status 1', iconOn: true }, */
    ],
    noEntryFound: {
      text: 'Bosch status undefined', textShort: 'Bosch status und.',
      iconOn: false,
    },
  };


  // MITSUBISHI

  mitsubishiUnitStatusDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Mitsubishi status error', textShort: 'Mitsubishi status error', iconOn: false },
      { value: '1', text: 'Mitsubishi status OK', textShort: 'Mitsubishi status OK', iconOn: true },
      { value: '-1', text: 'Mitsubishi status NC', textShort: 'Mitsubishi status NC', iconOn: false },
    ],
    noEntryFound: {
      text: 'Mitsubishi status undefined', textShort: 'Mitsubishi status und.',
      iconOn: false,
    },
  };



  // both 0 and 1 are low
  mitsubishiUnitFanSpeedDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Mitsubishi fan speed low', textShort: 'Mitsubishi fan speed low', iconOn: true },
      { value: '1', text: 'Mitsubishi fan speed low', textShort: 'Mitsubishi fan speed low', iconOn: true },
      { value: '2', text: 'Mitsubishi fan speed mid', textShort: 'Mitsubishi fan speed mid', iconOn: true },
      { value: '3', text: 'Mitsubishi fan speed high', textShort: 'Mitsubishi fan speed high', iconOn: true },
    ],
    noEntryFound: {
      text: 'Mitsubishi fan speed undefined', textShort: 'Mitsubishi fan speed und.',
      iconOn: false,
    },
  };

  mitsubishiunitOperationModeDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Mitsubishi mode heat', textShort: 'Mitsubishi mode heat', iconOn: true },
      { value: '1', text: 'Mitsubishi mode cool', textShort: 'Mitsubishi mode cool', iconOn: true },
      { value: '2', text: 'Mitsubishi mode auto', textShort: 'Mitsubishi mode auto', iconOn: true }
    ],
    noEntryFound: {
      text: 'Mitsubishi mode undefined',
       textShort: 'Mitsubishi mode undef.',
      iconOn: false,
    },
  };

        // HAIER
    haierUnitStatusDictionary: IPropDictionary = {
      entries: [
        { value: '0', text: 'Haier status error', textShort: 'Haier status error', iconOn: false },
        { value: '1', text: 'Haier status OK', textShort: 'Haier status OK', iconOn: true },
        { value: '-1', text: 'Haier status NC', textShort: 'Haier status NC', iconOn: false },
      ],
      noEntryFound: {
        text: 'Haier status undefined', textShort: 'Haier status und.',
        iconOn: false,
      },
    };

    // both 0 and 1 are low
  haierUnitFanSpeedDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Haier fan speed low', textShort: 'Haier fan speed low', iconOn: true },
      { value: '1', text: 'Haier fan speed low', textShort: 'Haier fan speed low', iconOn: true },
      { value: '2', text: 'Haier fan speed mid', textShort: 'Haier fan speed mid', iconOn: true },
      { value: '3', text: 'Haier fan speed high', textShort: 'Haier fan speed high', iconOn: true },
    ],
    noEntryFound: {
      text: 'Haier fan speed undefined', textShort: 'Haier fan speed und.',
      iconOn: false,
    },
  };

  haierUnitOperationModeDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Haier mode heat', textShort: 'Haier mode heat', iconOn: true },
      { value: '1', text: 'Haier mode cool', textShort: 'Haier mode cool', iconOn: true },
      { value: '2', text: 'Haier mode auto', textShort: 'Haier mode auto', iconOn: true }
    ],
    noEntryFound: {
      text: 'Haier mode undefined',
      textShort: 'Haier mode undef.',
      iconOn: false,
    },
  };

  // PANASONIC
    panasonicUnitStatusDictionary: IPropDictionary = {
      entries: [
        { value: '0', text: 'Panasonic status error', textShort: 'Panasonic status error', iconOn: false },
        { value: '1', text: 'Panasonic status OK', textShort: 'Panasonic status OK', iconOn: true },
        { value: '-1', text: 'Panasonic status NC', textShort: 'Panasonic status NC', iconOn: false },
      ],
      noEntryFound: {
        text: 'Panasonic status undefined', textShort: 'Panasonic status und.',
        iconOn: false,
      },
    };

    // both 0 and 1 are low
panasonicUnitFanSpeedDictionary: IPropDictionary = {
  entries: [
    { value: '0', text: 'Panasonic fan speed auto', textShort: 'Panasonic fan speed auto', iconOn: true },
    { value: '1', text: 'Panasonic fan speed low', textShort: 'Panasonic fan speed low', iconOn: true },
    { value: '2', text: 'Panasonic fan speed low+', textShort: 'Panasonic fan speed low+', iconOn: true },
    { value: '3', text: 'Panasonic fan speed medium', textShort: 'Panasonic fan speed medium', iconOn: true },
    { value: '4', text: 'Panasonic fan speed medium+', textShort: 'Panasonic fan speed medium+', iconOn: true },
    { value: '5', text: 'Panasonic fan speed high', textShort: 'Panasonic fan speed high', iconOn: true },
  ],
    noEntryFound: {
      text: 'Panasonic fan speed undefined', textShort: 'Panasonic fan speed und.',
      iconOn: false,
    },
  };

  panasonicUnitOperationModeDictionary: IPropDictionary = {
    entries: [
      { value: '0', text: 'Panasonic mode heat', textShort: 'Panasonic mode heat', iconOn: true },
      { value: '1', text: 'Panasonic mode cool', textShort: 'Panasonic mode cool', iconOn: true },
      { value: '2', text: 'Panasonic mode auto', textShort: 'Panasonic mode auto', iconOn: true }
    ],
    noEntryFound: {
      text: 'Panasonic mode undefined',
      textShort: 'Panasonic mode undef.',
      iconOn: false,
    },
  };

}
